import React, { useEffect, useState, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";
import benefiticon from "../../assets/images/Benefits icon 1 (1).webp"

const services = [
  {
    id: 1,
    title: "Targeted Advertising",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      "LinkedIn ads allow you to target specific audiences based on job title, industry, company size, and more.",
  },
  {
    id: 2,
    title: " High-Quality Leads",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    content1:
      "LinkedIn ads can help you generate high-quality leads, as users are more likely to be interested in business-related products and services.",
  },
  {
    id: 3,
    title: " Increased Brand Awareness",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    content1:
      "LinkedIn ads can help increase brand awareness and establish your company as a thought leader in your industry.",
  },
  {
    id: 4,
    title: "Measurable Results",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    content1:
      "LinkedIn provides measurable results, including engagement metrics, conversion tracking, and return on ad spend.",
  },
  {
    id: 5,
    title: "Cost-Effective",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    content1:
      "LinkedIn ads can be more cost-effective than traditional forms of advertising, as you only pay for ads that are clicked on.",
  },
];
const SocialLnAni = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px 0px -60% 0px", // triggers earlier when top is at 40% of viewport
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Number(entry.target.getAttribute("data-index"));
          setActiveIndex(index);
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div>
      <div className="">
        <div className="benefitsfont">benefits</div>
        <div className="benefithead">LinkedIn Ads</div>
           <div className="mb-5">
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-12">
                                    <div className="benefitwidth">
                                      <OwlCarousel
                                        className="owl-theme"
                                        loop
                                        autoplay={true}
                                        items="1"
                                        dots={false}
                                        smartSpeed={2000}
                                        nav={true}
                                        navText={[
                                          `<i class="fa fa-chevron-left"></i>`,
                                          `<i class="fa fa-chevron-right"></i>`,
                                        ]}
                                        margin={20}
                                        // center={true}
                                        autoplayTimeout={5000}
                                        responsive={{
                                          360: {
                                            items: "1",
                                          },
                                          414: {
                                            items: "1",
                                          },
                                          670: {
                                            items: "2",
                                          },
                                          992: {
                                            items: "3",
                                          },
                
                                          1200: {
                                            items: "3",
                                          },
                                        }}
                                      >
                                        {services.map((item, index) => {
                                          return (
                                           <div className="position-circle">
                                              <img  src={benefiticon} className='benefiticon' alt='icon'/>
                                              <div className="border-dot1">
                                           <div className="orange-circle">
                 
                                           </div>
                                           </div>
                                           <div className="carousel-wapp-card">
                                            
           <div>
             <div className="carouselwapp">
           {item.title}
             </div>
             <div className="carousel-para">
           {item.content1}
             </div>
           </div>
           
                                           </div>
                                           </div>
                                           
                                          );
                                        })}
                                      </OwlCarousel>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
      </div>
    </div>
  );
};

export default SocialLnAni;
